export var borderColor = 'var(--_1jljrbf1-3-12-1)';
export var rangeColor = 'var(--_1jljrbf0-3-12-1)';